/*
 * this the inoe api proxy
 *
 */
import axios, { AxiosError, AxiosResponse } from "axios";
import pdb from "@/db";
import mockdb from "@/db/mock";
import $inoe from "@/config";
import store from "@/store";
const qs = require("querystring");
import { SHOW_LOADING, CLOSE_LOADING } from "@/store/types";
import { IDB } from "@/db/idb";
import db from "@/db";
import { Pointage } from '@/models/Pointage';
import { Supplement } from '@/models/Supplement';
import { MobiDocument } from '@/models/MobiDocument';


if (process.env.VUE_APP_MOCK === "true") {
  localStorage.setItem("dossier", "mock");
  localStorage.setItem("token", "mock");
  localStorage.setItem("accesskey", "mock")
}
console.log(axios.defaults.baseURL);
//axios.defaults.headers.common['Authorization']=""
axios.defaults.headers.post["Content-Type"] = "application/json";


const FORM_URL_ENCODED_CONFIG = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "X-Requested-With": "XMLHttpRequest",
  },
};
let withLoading = (r: Promise<any>, showLoading: boolean = true) => {
  if (!showLoading) return r;
  store.dispatch(SHOW_LOADING);
  r.finally(() => {
    store.dispatch(CLOSE_LOADING);
  });
  return r;
};
// this the api proxy
function getDB(): IDB {
  if ($inoe.isApiMock) return mockdb;
  else return pdb;
}
class API {
  about = "inoe api";

  dbController = {
    initLocalDB(){
      return getDB().initLocalDB();
    },
    initRemoteDB(url: string, username: string, password: string){
      return getDB().initRemoteDB(url,username,password, false);
    },
    getLocalDBSize(){
      return getDB().getLocalDBSize();
    },
    getRemoteDBSize(){
      return getDB().getRemoteDBSize();
    },
    sync(config: any): any {
      return getDB().sync(config);
    },
    reset() {
      return getDB().reset();
    }
  };

      infoController = {
        async getClusterInfo(idDossier: string) {
          const baseUrl = process.env.VUE_APP_API_R_URL || "";
          const prodBaseUrl = process.env.VUE_APP_API_R_URLPROD || "";
          const url = `${baseUrl}${$inoe.getClusterMobiURL()}${idDossier}`;
          console.log("Réponse du serveur:", process.env.NODE_ENV);

          let resp = await axios.get(url);
          // Si cluster vide et environnement non-prod, on retente avec l’URL de prod
          if (
            process.env.NODE_ENV !== "production" &&
            (!resp.data.cluster || resp.data.cluster === "") &&
            prodBaseUrl
          ) {
            const retryUrl = `${prodBaseUrl}${$inoe.getClusterMobiURL()}${idDossier}`;
            console.warn("Cluster vide, nouvelle tentative avec URL de repli:", retryUrl);
            resp = await axios.get(retryUrl, {
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });
        }

          return resp;
        }
  };

  loginController = {
    login(url: string, username: string, password: string) {
      const authorization=$inoe.getAuthorisation()|| btoa(username + ":" + password);
      return axios.get(url,{
        headers:{
          "Authorization" : `Basic ${authorization}`
        }
      });
    },
  };

  pointagesController = {
    updateDocument(listDocument: Array<any>) {
      return withLoading(getDB().bulkDocuments(listDocument))
    },
    pointer(pointage: any) {
      return getDB().ajouterDocument(pointage);
    },
    supprimerPointage(documentId: string) {
      return getDB().supprimerDocument(documentId);
    },
    pointageMasse(listpointage: Array<Pointage>) {
      return withLoading(getDB().bulkDocuments(listpointage))
    },
    supplementMasse(listSupplement: Array<Supplement>) {
      return withLoading(getDB().bulkDocuments(listSupplement))
    },
    listPointages(date: any, currentActiviteId: number) {
      return (getDB().listPointages(date, currentActiviteId));
    },
    addSupplement(supplement: Supplement) {
      return withLoading(getDB().ajouterDocument(supplement));
    },
    listSupplementsActifs(date: any, activite_id: number) {
      return (getDB().listSupplementsActifs(date, activite_id));
    },
  };

  etablissementController = {
    listEtablissements() {
    },
  };

  userController = {
    listUsers() {
      return getDB().listUsers();
    },
    listUsersFromRemote() {
      return getDB().listUsersFromRemote();
    },
    usersLogged() {
      return getDB().usersLogged();
    }
  };


  individusController = {
    listEcoles() {
      return (getDB().listEcoles());
    },
    listClasses() {
      return (getDB().listClasses());
    },
    listInstit() {
      return (getDB().listInstit());
    },
    listHisto() {
      return (getDB().HistoScolarite());
    },
    listNiveau() {
      return (getDB().listNiveau());
    },
    listVille() {
      return (getDB().listVille());
    }
  };
  ParentsController = {

  };

  activitesContoller = {

  }
  DossierController = {

  }
}

export default new API();
